/**
 * Tracks whether the session is being torn down (logout / unrecoverable token
 * refresh failure). During teardown, in-flight and polled requests are expected
 * to fail; consumers use this to cancel work and suppress error reporting so a
 * logout does not produce a burst of Sentry noise.
 *
 * Leaf module — no imports — so it can be shared by auth-utils, the token
 * coordinator, and pollers without creating import cycles. The flag is one-way:
 * once set, the app is on its way to the login screen.
 */
let terminating = false;
const listeners = new Set<() => void>();

export function markSessionTerminating(): void {
  terminating = true;
  listeners.forEach((cb) => {
    try {
      cb();
    } catch {
      // a failing listener must not block teardown of the others
    }
  });
}

export function isSessionTerminating(): boolean {
  return terminating;
}

export function onSessionTerminating(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
